/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ debt: NonNullable<unknown>, excess: NonNullable<unknown> }} Carrier_Form_Cod_Override_Above_DebtInputs */

const vi_carrier_form_cod_override_above_debt = /** @type {(inputs: Carrier_Form_Cod_Override_Above_DebtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cao hơn số đơn còn nợ (${i?.debt}đ), dư ${i?.excess}đ. ERP chỉ ghi ${i?.debt}đ vào công nợ đơn này, phần dư chưa được ghi cho khách.`)
};

/**

* @param {Carrier_Form_Cod_Override_Above_DebtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_cod_override_above_debt = /** @type {((inputs: Carrier_Form_Cod_Override_Above_DebtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Cod_Override_Above_DebtInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_cod_override_above_debt(inputs)
});